import { useTranslation } from 'react-i18next';
import { Button } from '@/shared/components/ui/button';
import { FiltersPopover } from '@/shared/components/custom/filters-popover';
import { FloatingLabelInput } from '@/shared/components/custom/form-field/FloatingLabelInput';

interface MembersFiltersProps {
  search: string;
  onSearchChange: (value: string) => void;
  activeFiltersCount: number;
  onReset: () => void;
}

export function MembersFilters({
  search,
  onSearchChange,
  activeFiltersCount,
  onReset,
}: MembersFiltersProps) {
  const { t } = useTranslation('members');

  return (
    <FiltersPopover activeCount={activeFiltersCount} label={t('filters.trigger')}>
      <FiltersPopover.Content>
        <FloatingLabelInput
          id="members-search"
          label={t('filters.search')}
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          hasValue={!!search}
        />
        {activeFiltersCount > 0 && (
          <Button
            variant="ghost"
            size="sm"
            data-testid="members-filters-reset"
            onClick={onReset}
            className="w-full"
          >
            {t('filters.reset')}
          </Button>
        )}
      </FiltersPopover.Content>
    </FiltersPopover>
  );
}
